export default "__VITE_ASSET__Cv$Z7RQj__"